export default __webpack_public_path__ + "static/media/book4.cdfed4cc.svg";